import React from 'react'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'

const RSeguimientoServicio = ({ isOpen, onClose, title, childComponent, children, fullscreen = false, container, className = '', wrapClassName = '', size = 'xl', compact = false }) => {
    const backdropStyle = 'static';
    const modalStyle = fullscreen || compact
        ? undefined
        : {
              marginTop: '24px',
              marginBottom: '24px',
              height: `calc(100vh - 48px)`, // Altura del viewport menos el margen superior e inferior
              maxHeight: 'calc(100vh - 48px)', // Asegura que no se exceda la altura disponible
          };
    return (
        <Modal

            isOpen={isOpen}
            backdrop={backdropStyle}
            keyboard={false}
            fade={false}
            autoFocus={false}
            scrollable={true}
            unmountOnClose={true}
            size={fullscreen ? undefined : size}
            zIndex={9999}
            style={modalStyle}
            fullscreen={fullscreen}
            container={container}
            className={className}
            wrapClassName={wrapClassName}
        >
            <ModalHeader toggle={onClose}>{title}</ModalHeader>
            <ModalBody>
                {childComponent ?? children}
            </ModalBody>
        </Modal >
    )
}

export default RSeguimientoServicio
